<script setup>
import { ref } from 'vue'
import SurveyComponent from './components/SurveyComponent.vue'
import LandingPage from './components/LandingPage.vue'

const showSurvey = ref(false)

const startSurvey = () => {
  showSurvey.value = true
}
</script>

<template>
  <LandingPage v-if="!showSurvey" @start-survey="startSurvey" />
  <SurveyComponent v-else />
</template>

<style>
@import 'survey-core/defaultV2.min.css';
</style>
